// import Flickity from "flickity";
// require("flickity-imagesloaded");
// require("flickity-fade");

export default function gallery() {}

// export default function gallery() {
//   const element = document.querySelector(".gallery__slideshow");
//   new Flickity(element, {
//     autoPlay: 4000,
//     pageDots: false,
//     prevNextButtons: false,
//     cellAlign: "left",
//     fade: true,
//     draggable: false,
//     pauseAutoPlayOnHover: false,
//     imagesLoaded: true,
//   });
// }
